import ClassNames from '@streamloots/classnames';
import { PageFeedComment } from 'model/indexTS';
import { Badge, BadgeColorsType } from 'ui-library/badge';
import { TranslateInterface } from 'utils/translation';
import { currencyManager } from 'services/culture';
import { Currency } from '@streamloots/streamloots-types';
import { useFeedComments } from './useFeedComments';
import { FeedCommentActions } from './FeedCommentActions';
import { ActionWithLogin } from '../action-with-login';
import { FooterButton } from '../footer-button';
import theme from './feed-comments.scss';

const classNames = ClassNames(theme);

const LOCATION = 'feed comment content';

export interface FeedCommentFooterProps extends TranslateInterface {
  feedComment: PageFeedComment;
  color?: BadgeColorsType;
  isPreview?: boolean;
}

export const FeedCommentFooter = ({
  feedComment,
  color,
  t,
  isPreview = false,
}: FeedCommentFooterProps): JSX.Element | null => {
  const { feed, page, isStaff, user, isUserAuthenticated, handleLikeComment } = useFeedComments();
  const formattedAmount = currencyManager.getFormattedPrice(
    feedComment.tippedAmount,
    feedComment.tippedCurrency ?? Currency.EUR,
  );
  const onLikeClick = () => {
    handleLikeComment(feedComment);
  };

  const fullPermission =
    isUserAuthenticated && (page.isOwner || isStaff || feedComment.userId === user?._id || isPreview);

  return (
    <div className={classNames('feed-comment-footer')}>
      <div className={classNames('feed-comment-footer__section')}>
        <ActionWithLogin feed={feed} page={page} isAuthenticaded={isUserAuthenticated} location="like content comment">
          <FooterButton
            active={feedComment.summary.liked}
            buttonId={feedComment.summary.liked ? 'unlike' : 'like'}
            commentCount={1}
            contentId={feedComment._id}
            icon="heart"
            label={feedComment.summary.reactionCount > 0 ? `${feedComment.summary.reactionCount}` : ''}
            likeCount={
              feedComment.summary.liked ? feedComment.summary.reactionCount - 1 : feedComment.summary.reactionCount + 1
            }
            onClick={onLikeClick}
            title={
              feedComment.summary.liked
                ? t('pageFeed:feedDetail.summary.unlike')
                : t('pageFeed:feedDetail.summary.like')
            }
            location={LOCATION}
          />
        </ActionWithLogin>

        {!feedComment.publicMessage && (
          <div className={classNames('feed-comment-footer__private')}>{t('pageFeed:feedDetail.comments.private')}</div>
        )}
      </div>
      {fullPermission && ( // the full permission here too seems redunant. But it's just to remember it when we add the like button
        <div className={classNames('feed-comment-footer__section')}>
          {feedComment.hasTipped && <Badge label={formattedAmount} color={color} />}
          {!isPreview && <FeedCommentActions feedComment={feedComment} t={t} />}
        </div>
      )}
    </div>
  );
};
